<template>
  <div>
    <v-row v-if="loading" align="center" justify="center" no-gutters class="my-6">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-row>

    <div v-else-if="ethernetInterfacesItems" class="pt-3">
      <v-alert v-if="connectedInterfacesCount.length < 2" color="warning" icon="warning" dark class="mt-3 mb-3">
        You cannot deactivate the last interface as all the others are already disabled, and thus, you will lose the
        connection with the Router.
      </v-alert>

      <v-row>
        <v-col v-for="ethernetInterface in ethernetInterfacesItems" :key="ethernetInterface['.id']">
          <v-card outlined>
            <v-card-text class="d-flex align-center">
              <v-icon :color="getIconColor(ethernetInterface.state)" class="pr-5">
                mdi-circle
              </v-icon>
              <v-icon left size="50">{{ getIconByName(ethernetInterface.name) }}</v-icon>
              <div>{{ ethernetInterface.name }}</div>
              <v-spacer />
              <v-switch
                :disabled="connectedInterfacesCount.length < 2 && ethernetInterface.disabled === 'false'"
                :input-value="ethernetInterface.disabled === 'false'"
                :loading="updateInterfaceDisabledLoading"
                hide-details
                class="ma-0"
                @change="updateRouterosInterfaceDisabled(ethernetInterface['.id'], !$event)"
              ></v-switch>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import fetch from '@/utils/fetch'

export default {
  name: 'SiteVpnMikrotikInterfaces',
  props: {
    siteVpn: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadingEthernetInterfaces: false,
      ethernetInterfaces: [],
      updateInterfaceDisabledLoading: false,
      loadingInternetState: false,
      isLoading: false,
      internetState: []
    }
  },
  computed: {
    loading() {
      return this.loadingEthernetInterfaces || this.loadingInternetState || this.isLoading
    },
    ethernetInterfacesItems() {
      if (!this.ethernetInterfaces || !this.internetState) {
        return
      }
      this.ethernetInterfaces.forEach(item1 => {
        const matchingItem = this.internetState.find(item2 => item2['.id'] === item1['.id'])
        if (matchingItem) {
          item1.state = matchingItem.state
        }
      })
      return this.ethernetInterfaces
    },
    connectedInterfacesCount() {
      return this.ethernetInterfacesItems.filter(item => item.disabled === 'false' && item.state === 'internet')
    }
  },

  mounted() {
    this.getRouterosData()
  },
  methods: {
    getRouterosData() {
      this.getRouterosEthernetInterfaces()
      this.getRouterosInternetState()
    },
    getRouterosInternetState() {
      this.loadingInternetState = true
      fetch(this.siteVpn['@id'] + '/routeros/internet_state')
        .then(response => response.json())
        .then(data => {
          this.internetState = data
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loadingInternetState = false
        })
    },
    getRouterosEthernetInterfaces() {
      this.loadingEthernetInterfaces = true
      fetch(this.siteVpn['@id'] + '/routeros/ethernet_interfaces')
        .then(response => response.json())
        .then(data => {
          this.ethernetInterfaces = data
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loadingEthernetInterfaces = false
        })
    },

    updateRouterosInterfaceDisabled(id, value) {
      if (this.connectedInterfacesCount.length < 2 && value === true) {
        return
      }
      this.updateInterfaceDisabledLoading = true
      fetch(this.siteVpn['@id'] + '/routeros/interface_disabled/' + id, {
        method: 'PUT',
        body: JSON.stringify({
          disabled: value
        })
      })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.updateInterfaceDisabledLoading = false
          this.isLoading = true
          setTimeout(() => {
            this.getRouterosData()
            this.isLoading = false
            this.$emit('reload')
          }, 3000)
        })
    },

    getIconColor(state) {
      return state === 'internet' ? 'green' : 'red'
    },
    getIconByName(name) {
      if (name.includes('VSAT')) {
        return 'mdi-satellite-variant'
      }

      if (name.includes('OFICINA')) {
        return 'mdi-office-building'
      }

      if (name.includes('FO')) {
        return 'mdi-toslink'
      }

      if (name.includes('STARLINK')) {
        return 'mdi-satellite-uplink'
      }

      if (name.includes('GLOBAL')) {
        return 'mdi-earth'
      }

      if (name.includes('REGIONAL')) {
        return 'mdi-map-marker-outline'
      }

      return 'mdi-ethernet'
    }
  }
}
</script>
